import _actions_change from './_actions/change.js'
import _getters_data from './_getters/data.js'
import _mutations_set from './_mutations/set.js'
import _mutations_loading from './_mutations/loading.js'
import _mutations_clean from './_mutations/clean.js'
import state from './state.js'

export default {
    namespaced: true,
    state,
    mutations:{
        clean: _mutations_clean,
        loading: _mutations_loading,
        set: _mutations_set,
    },
    getters:{
        data: _getters_data,
    },
    actions:{
        change: _actions_change,
    },
}